import { Center, Modal } from "@mantine/core"
import { notifications } from "@mantine/notifications"
import { Button } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { useReopenRequestMutation } from "~/pages/SupplierPortal/TraceabilityRequests/hooks.ts"

interface Props {
  requestId: number
  mode: "clean" | "dirty"
  opened: boolean
  onClose: () => void
}

export const ReopenRequestModal = ({
  requestId,
  mode,
  opened,
  onClose,
}: Props) => {
  const { t } = useTranslation(["traceability"])
  const { mutate: reopen, isLoading } = useReopenRequestMutation({
    onSuccess: (data) => {
      notifications.show({
        title: "Feedback",
        message: t("reopenRequest.feedback", { count: data.count }),
      })
      onClose()
    },
    onError: () => {
      notifications.show({
        title: "Feedback",
        message: t("reopenRequest.error"),
        color: "red",
      })
    },
  })

  return (
    <>
      <Modal
        opened={opened}
        onClose={onClose}
        title={t("reopenRequest.title")}
        centered
      >
        <Center>
          <Button
            onClick={() => {
              reopen({ requestId, mode })
            }}
            loading={isLoading}
            color="yellow"
            variant="secondary"
          >
            {t("reopenRequest.yes")}
          </Button>
        </Center>
      </Modal>
    </>
  )
}
